import { Tool } from './Tool';
export class ZoomInTool extends Tool {
    constructor() {
        super('Zoom In', new URL('../../assets/plus.svg', import.meta.url).href);
    }
    execute(mapInstance) {
        if (!mapInstance) {
            console.warn('Map instance is not available.');
            return;
        }
        const currentZoom = mapInstance.getZoom();
        mapInstance.zoomTo(currentZoom + 1, { duration: 500 });
    }
}
//# sourceMappingURL=ZoomInTool.js.map